import React, { Component } from 'react';
import { connect } from 'react-redux';
import CsvDownloader from 'react-csv-downloader';
import { startTest, cancelTest } from '../actions';
import { MemberTypes, ResultStatuses, SKUS } from '../constants';
import ResultUtils from '../utils/ResultUtils';
import PayerSelect from '../components/PayerSelect';
import SkuSelect from '../components/SkuSelect';

export class TestOptionsUnconnected extends Component {
  constructor(props) {
    super(props);

    this.state = this.defaultValues();
    this.handleChange = this.handleChange.bind(this);
    this.handleCostChange = this.handleCostChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  defaultValues() {
    const { payers } = this.props;

    // Convert cost data to map of sku code to cost
    const consultCost = SKUS.reduce((result, { skuCode, defaultCost }) => (
      {
        ...result,
        [skuCode]: defaultCost
      }
    ), {});

    return {
      consultCost,
      payerId: this.props.selectedPayer || payers[0].payerId,
      skuCodes: ['GMMDCONSULT']
    };
  }

  handleChange(name, value) {
    // Form elements invoke this change handler with the element name and value,
    // which we store in the state.
    this.setState({ [name]: value });
  }

  handleCostChange(skuCode, cost) {
    // Use the functional version of setState because new state depends on existing
    // (We get only the updated value, not the full state)
    this.setState(({ consultCost: prevConsultCost }) => {
      const consultCost = {
        ...prevConsultCost,
        [skuCode]: cost
      };
      return { consultCost };
    });
  }

  handleSubmit(event) {
    const { members, startTest: startTestAction } = this.props;
    const options = this.state;

    event.preventDefault();
    startTestAction(ResultUtils.initialTestResults(members, options));
  }

  renderDynamicFields() {
    const { memberType, payers } = this.props;

    switch (memberType) {
      case MemberTypes.CSV_FILE:
        return (
          <PayerSelect
            payers={payers}
            allowBlank={false}
            onChange={this.handleChange}
            defaultValue={this.defaultValues().payerId}
            wrapTableRow
          />
        );
      default:
        return (
          <tr />
        );
    }
  }

  renderButtons() {
    const { results, cancelTest: cancelTestAction } = this.props;
    const status = ResultUtils.testStatus(results);

    return (
      <span>
        <button
          className="start-options-button"
          type="submit"
          disabled={status === ResultStatuses.LOADING}
        >
          Start Test
        </button>
        &nbsp;

        <button
          className="cancel-options-button"
          type="button"
          disabled={status !== ResultStatuses.LOADING}
          onClick={cancelTestAction}
        >
          Cancel Test
        </button>
        &nbsp;

        <CsvDownloader
          filename="results.csv"
          separator=","
          columns={ResultUtils.RESULT_COLUMNS}
          datas={results || []}
        >
          <button
            className="download-options-button"
            type="button"
            disabled={status !== ResultStatuses.COMPLETE && status !== ResultStatuses.ERROR && status !== ResultStatuses.CANCELED}
          >
            Download Results
          </button>
        </CsvDownloader>
        &nbsp;
      </span>
    );
  }

  componentDidUpdate(prevProps) {
    if (this.props.selectedPayer !== prevProps.selectedPayer) {
      this.setState({
        payerId: this.props.selectedPayer
      });
    }
  }

  render() {
    const { members } = this.props;

    if (!members) {
      return <div />;
    }

    return (
      <div className="search test-options">
        <h4>Test Options</h4>
        <form onSubmit={this.handleSubmit}>
          <table>
            <tbody>
              {this.renderDynamicFields()}
              <SkuSelect
                onSelectionChange={this.handleChange}
                onCostChange={this.handleCostChange}
                defaultSelection={this.defaultValues().skuCodes}
              />
            </tbody>
          </table>
          {this.renderButtons()}
        </form>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { memberType, members, results, selectedPayer } = state.rteTest;

  return { memberType, members, results, selectedPayer };
};

const mapDispatchToProps = { startTest, cancelTest };

export default connect(mapStateToProps, mapDispatchToProps)(TestOptionsUnconnected);
